module.exports = __webpack_public_path__ + "7eb413dddbf3bb16623758f043a9151d.svg";